export default __webpack_public_path__ + "static/media/reporting-planet.94630160.png";